module.exports = __webpack_public_path__ + "static/media/banner-games-bg-flat.d902bea4.svg";